import React from "react";
import "./Intellikid.css";
import phone from "../../assets/tt.gif";
import Userflow from "../../assets/Userflow.png";
import intelliPrototype from "../../assets/intelliPrototype.png";
import commonalities from "../../assets/commonalities.png";
import usertesting from "../../assets/usertesting.png";
import intellipersona from "../../assets/persona.png";
export default function Intellikid() {
  return (
    <>
      <div className="intelli-section">
        <div className="intelli-about">
          <h4>INTELLIKID MOBILE APP </h4>
          <p className="intelli-about-status">
            IntelliKid is an app to help families with disabilities who often
            struggle to find extra-curricular activities that are appropriate
            for their child's special needs. Programs are few and far between,
            poorly advertised and therefore difficult to find, and often end up
            getting cancelled due to inadequate registration.​ ​Agencies that
            render/ offer services can also post services for prospective
            clients​ ​ The app has been developed for iOS utilizing the UX
            DESIGN PROCESS as seen on the RHS of this screen.​ Families with
            children.
            <br />
            Click{" "}
            <a
              href="https://www.figma.com/proto/ReIqgrSir2Oxhuyen4MCvJ/IntelliKid?node-id=2%3A2&scaling=scale-down&page-id=0%3A1&starting-point-node-id=2%3A2"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            to see view the interactive design .
          </p>
          <br />
        </div>
        <div className="intelli-content">
          <img
            src={phone}
            alt=" a pic displaying quick demo of intellikid App"
            style={{ width: "100%", height: "40rem" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>User Research</h4>
          <p className="intelli-about-status">
            At the inception of this project, The user research phase was
            conducted by my team and I. We gathered data via contextual
            interviews from parents of kid with disabilities living in Ottawa to
            understand their challenges, behaviours, progress, Frustrations and
            goals in enrolling their kids for extra activities. I proceeded with
            a list to display the commonality patterns to narrow down the
            painpoints common with all the users
          </p>
          <br />
        </div>

        <div className="intelli-demo">
          <img
            src={commonalities}
            alt=" a pic displaying list of commonalities patterns"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>Analysis and Personas</h4>
          <p className="intelli-about-status">
            I proceeded to​ synthesize the result/ responses collectively
            gathered by my team and this helped to create Personas. Our persona
            research spread sheet can be found{" "}
            <a
              href="https://algonquinlivecom-my.sharepoint.com/:x:/g/personal/dudh0004_algonquinlive_com/EYIa9XnPFodKmOtc4dqET8ABeQ0SmrmkCuQv9WC_aZxv_w?e=fm6clu"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            . After which I proceeded to find Find commonalities- list of
            patterns.​The commonalities found was the basis of the personas
            deduced.
          </p>
          <br />
        </div>

        <div className="intelli-demo">
          <img
            src={intellipersona}
            alt="Primary Persona"
            style={{ width: "60rem", height: "	100%" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4> Problem Statement</h4>
          <p className="intelli-about-status">
            From the personas, I was able to empathize with my users to
            understand their core needs without bias. I found out that it is
            often difficult for parents to easily find/ schedule service
            providers for kids with disabilities. The Pandemic particularly made
            it difficult as it was more difficult securing a a virtual spot. The
            service Providers too have difficulties getting new clients and so
            both personas need an application that can connect them and help
            them schedule visits.
          </p>
          <br />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>Information Architecture</h4>
          <p className="intelli-about-status">
            The Information architecture on the right hand side displays the
            organizing and structuring content of the mobile App. It aims at
            organizing content so that users would easily adjust to the
            functionality of the product and could find everything they need
            without big effort. The yellow boxes are the primary navigation
            which lead the user through secondary and other navigations.
          </p>
          <br />
        </div>

        <div className="intelli-demo">
          <img
            src={Userflow}
            alt=" a pic displaying information architecture for intellikid "
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>Prototypes</h4>
          <p className="intelli-about-status">
            After Ideating, I decided to come up with a quick solution(initial
            GUI Plan). This interface is an outline GUI structure designed using
            Whimsical as low fidelity interface. This was later converted to a
            greyscale digital wireframe and further converted to High fidelity
            interface using Figma.
          </p>
          <br />
        </div>

        <div className="intelli-demo">
          <img
            src={intelliPrototype}
            alt=" a pic displaying the Lo, Mid and Hi Fidelity prototype of intellikid"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>Usability Testing</h4>
          <p className="intelli-about-status">
            Each Prototype phase ranging from low fidelity through mid fidelity
            and then high fidelity were accompanied by user testing, so as to
            ensure that the needed solution was proferred. The test partcipants
            were asked to complete the following scenarios: <br />
            1. Create a user Profile
            <br />
            2. Book an appointment.
            <br />
            3. Post an activity as a agency.
            <br />
            The participants were asked to rate according to their satisfaction
            and give feedback on what they recommend. These feedbacks were taken
            and further implemented in the final prototype. Please click{" "}
            <a href="https://algonquinlivecom-my.sharepoint.com/:p:/g/personal/onib0002_algonquinlive_com/ETglcp--9RJOt8QnFrbJ7iYB86LLVo9NR1N33QaWPHLMPQ?e=jFgPhJ">
              here
            </a>{" "}
            to view the comprehensive case study of the UI/UX Design Process.
          </p>
          <br />
        </div>

        <div className="intelli-demo">
          <img
            src={usertesting}
            alt=" a pic displaying recomendations from usability testing"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="intelli-section">
        <div className="intelli-about">
          <h4>Next Step</h4>
          <p className="intelli-about-status">
            The parent categories is complete although it is open for more
            improvements in the future, However, the Agencies/Service Providers
            categories needs a more robust platform like where they can
            advertise etc.
          </p>
        </div>
      </div>
    </>
  );
}
